import { render, staticRenderFns } from "./create_kimi.vue?vue&type=template&id=c4acc5ce&scoped=true"
import script from "./create_kimi.vue?vue&type=script&lang=js"
export * from "./create_kimi.vue?vue&type=script&lang=js"
import style0 from "./create_kimi.vue?vue&type=style&index=0&id=c4acc5ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4acc5ce",
  null
  
)

export default component.exports